
import { ResizeableType, WBComponent } from "./WBComponent";
import { WBRenderProps } from "vagaro-website-rendering/src/components/Definitions/WBRenderProps";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import LayoutNode, { getNodeComponentAttributeValue, getNodeStyleAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { GetNodeDomAttributes } from "vagaro-website-rendering/src/components/Utilities/GetNodeDomAttributes";
import { ScreenSize } from "vagaro-website-rendering/src/components/Definitions/ScreenSize";
import React from "react";
import CreateAttributeList, { attributeTypes, gridAttributes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import WebDesigner from "../WebDesigner";
import { AttributeDefinition, AttributeInputType, CreateConditionalAttribute } from "../Data/WBData";
import { GetGridStylingString, RenderGrid } from "../Utilities/GridUtils";




export default class WBGrid extends WBComponent {

  constructor() {
    super();
    this.typename = wBComponentTypeNames.grid;
    this.dropList = [wBComponentTypeNames.pageRoot, wBComponentTypeNames.section, wBComponentTypeNames.container,wBComponentTypeNames.footer];
    this.displayName = "Grid";
    this.primaryEditAttributes = ["gridSize"];
    this.editList = [
      gridAttributes.gridGapX,
      gridAttributes.gridGapY,
      gridAttributes.gridRatio,
      gridAttributes.forcePreview,
      ...this.primaryEditAttributes,
      gridAttributes.gridTemplateColumns,
      gridAttributes.gridTemplateRows,
      ...CreateAttributeList(true, true, true, true, true).filter((x) => x != attributeTypes.padding && x != attributeTypes.gap), // add all attributes except grid size
    ];

    this.resizeType = ResizeableType.VerticalOnly;
    this.resizeVisibilty = [false, false, false]



    this.icon = <svg xmlns="http://www.w3.org/2000/svg" height={"1em"} fill="currentColor" viewBox="0 0 512 512"><path d="M464 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h416c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zM197.3 72h117.3v96H197.3zm0 136h117.3v96H197.3zm-40 232H52c-6.6 0-12-5.4-12-12v-84h117.3zm0-136H40v-96h117.3zm0-136H40V84c0-6.6 5.4-12 12-12h105.3zm157.4 272H197.3v-96h117.3v96zm157.3 0H354.7v-96H472zm0-136H354.7v-96H472zm0-136H354.7V72H472z" /></svg>
  }


  GetComponentGlobalCSS(node: LayoutNode, isEditor?: boolean, isLivePublish?: boolean): string {
    const realid = (isEditor) ? "#" + node.id : "#v" + node.id;



    let str = GetGridStylingString(node, ScreenSize.Desktop, realid); // get the main grid styling

    for (let i = 1; i < 3; i++) { // create a style for each override
      let rows = getNodeStyleAttributeValue(node, i, gridAttributes.gridTemplateRows, "");
      let cols = getNodeStyleAttributeValue(node, i, gridAttributes.gridTemplateColumns, "");
      let gap = getNodeStyleAttributeValue(node, i, attributeTypes.gap, "");
      if (rows != "" || cols != "" || gap != "") {

        let prefix = (i == ScreenSize.Mobile) ? `.mobile-break ${realid}` : `.tablet-break ${realid}`;

        str += GetGridStylingString(node, i, prefix);
      }

    }

    return str;
  }


  onFirstTimeCreation(newParent: LayoutNode, thisLayout: LayoutNode, manager: WebDesigner): void {

  }

  getComponentSpecificAttributeDefinitions(): AttributeDefinition[] {

    return [

      new AttributeDefinition("gridSize", "Grid Size", "", AttributeInputType.gridSize),

    ]
  }



  RenderLayout({ component, children, screenSize, isEditor, userContext }: WBRenderProps): JSX.Element {

    let forceOpacity = getNodeComponentAttributeValue(component, gridAttributes.forcePreview, "") != "";
    let atts = GetNodeDomAttributes("v-grid relative w-full", component, screenSize, isEditor);


    return <div {...atts}>
      <RenderGrid isEditor={isEditor} node={component} screenSize={screenSize} showOverlay={isEditor} forceOverlay={forceOpacity}>
        {children}
      </RenderGrid>
    </div>

  }





}
